import SEO from '../components/SEO';

const ReturnPolicyPage = () => (
  <main className="bg-surface min-h-screen">
    <SEO
      title="Return & Refund Policy | Aspire Academy & MathMap"
      description="Refund and cancellation policy for Aspire Academy tuition sessions and MathMap subscriptions."
      path="/return-policy"
    />

    <div className="container-main py-16 md:py-24 max-w-3xl">
      <span className="label-uppercase text-aspire-red">Legal</span>
      <h1 className="heading-hero mt-2 mb-4">Return &amp; Refund Policy</h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: April 2025</p>

      <div className="space-y-8 text-gray-700 leading-relaxed">

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">1. Overview</h2>
          <p>
            This policy applies to all tuition sessions booked through Aspire Academy and to
            MathMap subscriptions. We aim to be fair and transparent — if you have a concern
            not covered here, please contact us directly.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">2. Trial Session</h2>
          <p>
            Your first class at Aspire Academy is completely free. No payment is taken and
            therefore no refund applies for trial sessions.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">3. Tuition Sessions — Cancellations</h2>
          <ul className="list-disc pl-6 space-y-3">
            <li>
              <strong>Cancelled by student (more than 24 hours' notice):</strong> Full credit
              applied to your next session. No charge.
            </li>
            <li>
              <strong>Cancelled by student (less than 24 hours' notice):</strong> The session
              fee is forfeited unless exceptional circumstances apply (e.g. medical emergency
              with documentation).
            </li>
            <li>
              <strong>Cancelled by Aspire Academy:</strong> A full credit or reschedule will
              be offered. If a reschedule is not suitable, a full refund will be issued within
              7 business days.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">4. Prepaid Session Packages</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Unused sessions from a prepaid package may be refunded on a pro-rata basis within 30 days of purchase.</li>
            <li>After 30 days, unused sessions are non-refundable but may be transferred to another student with approval.</li>
            <li>Package sessions are valid for 3 months from date of purchase.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">5. MathMap Subscriptions</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Monthly subscriptions:</strong> You may cancel at any time. Your access continues
              until the end of the current billing period. No partial-month refunds are issued.
            </li>
            <li>
              <strong>Annual subscriptions:</strong> Refunds are available within 14 days of purchase
              if you have not accessed more than 10% of the content. After 14 days, the subscription
              is non-refundable.
            </li>
            <li>
              <strong>Technical issues:</strong> If MathMap is unavailable for more than 48 consecutive
              hours due to a platform fault, a pro-rata credit will be applied to your account.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">6. How to Request a Refund</h2>
          <p>To request a refund or credit, contact us within the applicable window:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Email: <a href="mailto:info@aspireacademy.com.lk" className="text-aspire-red hover:underline">info@aspireacademy.com.lk</a></li>
            <li>WhatsApp: <a href="https://wa.me/94743652899" className="text-aspire-red hover:underline">+94 74 365 2899</a></li>
          </ul>
          <p className="mt-3">
            Please include your name, the session date or subscription period, and the reason for
            your request. We will respond within 2 business days.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">7. Refund Processing</h2>
          <p>
            Approved refunds are processed within <strong>7 business days</strong> and returned
            to the original payment method. Bank processing times may add 3–5 additional days
            depending on your provider.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">8. Exceptions</h2>
          <p>
            We handle exceptional circumstances (illness, bereavement, force majeure) with
            discretion on a case-by-case basis. Please reach out to us — we will always try
            to find a fair solution.
          </p>
        </section>

      </div>
    </div>
  </main>
);

export default ReturnPolicyPage;
